import styled from "styled-components";
import { Button } from "react-bootstrap";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AddressForm from "../AddressForm";
import HausflixNotice from "../HausflixNotice";
import checkedImage from "../../images/check.png";
import errorImage from "../../images/error-icon-32.png";
import { appendScriptHtml } from "../../services/helper";
import { updateLeadId } from "../../store/slices/funnelInfo";
import { FUNNEL_DESIGNS } from "../../templates/strings";
import { clearOtpSession } from "../../store/slices/otpSlice";

const SpacingText = styled.p`
  white-space: break-spaces;
`;
const ThanksButton = styled(Button)`
  border: none;
  font-size: 18px;
  font-weight: 600;
  border-radius: 4px;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  &:hover {
    background-color: ${({ $backgroundColor }) => $backgroundColor} !important;
  }
`;

export const Greet = ({ leadError }) => {
  const dispatch = useDispatch();
  const { funnel } = useSelector((state) => state.funnelInfo);
  const reclaimMode = useSelector((state) => state.reclaimMode);
  const baseColor = funnel.design?.baseColor;
  const websiteUrl = funnel.companyInfo?.companyWebsite;
  const thankyouPage = reclaimMode.enabled
    ? reclaimMode.globalReclaimConfig.thankyouPage
    : funnel.thankyouPage;

  const {
    thankyouPageHeadline,
    thankyouPageText,
    greetingPhrase,
    websiteButton,
    websiteButtonText,
    enableAddressAfterLeadGeneration
  } = thankyouPage;

  const thankyouPageScript = reclaimMode.enabled
    ? reclaimMode.globalReclaimConfig.scriptThankyou
    : funnel.scriptThankyou;

  useEffect(() => {
    appendScriptHtml(thankyouPageScript, document.head);
  }, [thankyouPageScript]);

  useEffect(() => {
    clearOtpSession();
    return () => {
      dispatch(updateLeadId(null));
    };
  }, [dispatch]);

  return (
    <div className="px-3 pt-4 px-md-5 text-center">
      <div>
        {!leadError ? (
          <img
            width={"128px"}
            height={"128px"}
            src={checkedImage}
            alt="successfull"
          />
        ) : (
          <img width={"128px"} height={"128px"} src={errorImage} alt="Error" />
        )}
      </div>
      <div className="fs-6 pt-3">
        {!leadError ? (
          <>
            <p className="fw-bold mt-2">{thankyouPageHeadline}</p>
            <SpacingText className="m-0">{thankyouPageText}</SpacingText>
            <HausflixNotice />
            <div className="mb-4" />
            {websiteButton === "Yes" && (
              <a href={websiteUrl}>
                <ThanksButton
                  className="text-white"
                  $backgroundColor={baseColor}
                >
                  {websiteButtonText}
                </ThanksButton>
              </a>
            )}
            <SpacingText className="fw-bold mt-4">{greetingPhrase}</SpacingText>
            {funnel.funnelDesign === FUNNEL_DESIGNS.CLASSIC &&
              enableAddressAfterLeadGeneration && <AddressForm />}
          </>
        ) : (
          <>
            <p className="fw-bold">Request Failed</p>
            <p>{leadError}</p>
          </>
        )}
      </div>
    </div>
  );
};
